import React from "react";
import { Table } from "antd";
// import dayjs from "dayjs";
import { convertUtcToIst } from "../../../../helpers/utility";

const Vitals = ({ details }) => {
  const vitals = details?.data?.vitals;

  const columns = [
    {
      title: "Started On",
      dataIndex: "action_time",
      key: "action_time",
      render: (value) => convertUtcToIst(value, true, true),
    },
    {
      title: "Temperature",
      dataIndex: "temperature",
      width: "10%",
    },
    {
      title: "Pulse Rate",
      dataIndex: "pulse",
      width: "10%",
    },
    {
      title: "Respiratory Rate",
      dataIndex: "respiration",
      width: "10%",
    },
    {
      title: "SPO2",
      dataIndex: "oxygen_saturation",
      width: "10%",
    },
    {
      title: "Systolic Pressure",
      dataIndex: "systolic_pressure",
      width: "10%",
    },
    {
      title: "Diastolic Pressure",
      dataIndex: "diastolic_pressure",
      width: "10%",
    },
    {
      title: "GRBS",
      dataIndex: "grbs",
      width: "10%",
    },
    {
      title: "Insulin",
      dataIndex: "insulin",
      width: "10%",
    },
  ];

  return (
    <div>
      <Table
        dataSource={vitals}
        pagination={false}
        columns={columns}
        scroll={{ x: "400px" }}
      />
    </div>
  );
};

export default Vitals;
